import Navigation from "@/components/Navigation";
import { ConsultationForm } from "@/components/ConsultationForm";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const HairSupplements = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <div className="pt-24 pb-12 px-6 max-w-7xl mx-auto">
        <h1 className="text-4xl font-serif mb-8">Hair Supplements</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div>
            <p className="text-lg mb-6">
              Our specially formulated hair supplements provide essential nutrients to support
              healthy hair growth and maintenance from within. Each supplement is carefully
              crafted with scientifically-backed ingredients to promote stronger, thicker,
              and healthier hair.
            </p>
            <h2 className="text-2xl font-serif mb-4">Benefits</h2>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>Supports natural hair growth</li>
              <li>Strengthens hair follicles</li>
              <li>Provides essential vitamins and minerals</li>
              <li>Improves overall hair health</li>
              <li>Reduces hair breakage and thinning</li>
            </ul>
            <Dialog>
              <DialogTrigger className="bg-primary text-white px-6 py-3 rounded-full hover:bg-primary/90 transition-colors">
                Schedule Consultation
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Schedule a Consultation</DialogTitle>
                </DialogHeader>
                <ConsultationForm />
              </DialogContent>
            </Dialog>
          </div>
          <div className="space-y-6">
            <img
              src="/lovable-uploads/57b53a43-b8f1-43f8-ba01-417c651840b0.png"
              alt="Hair supplements and treatment"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HairSupplements;